// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calculatedRankOverlay_calcResult__1S-ej {\n  padding: 1rem;\n  padding-right: 3rem;\n}\n.calculatedRankOverlay_calcResult__1S-ej span {\n  text-transform: uppercase;\n  font-size: 0.9rem;\n}\n.calculatedRankOverlay_calcResult__1S-ej > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 150px;\n}", ""]);
// Exports
exports.locals = {
	"calcResult": "calculatedRankOverlay_calcResult__1S-ej"
};
module.exports = exports;
